import axios from 'axios';
import { config } from 'config';
import cookie from 'cookie';

const KINESIS_ENDPOINT = '/api/kinesis';
const STREAM_ARN = 'arn:aws:kinesis:eu-central-1:093173765289:stream/eventtracking';

interface DataSchema {
  eventName: string;
  schemaVersion: string;
  commitHash?: string;
  releaseVersion: string;
  timestamp: string;
  metadata: {
    referer: string;
    sessionId: string;
    userAgent: string;
    url: string;
    customerId?: string;
    ninetailedAudiences?: string;
    ninetailedExperiences?: string;
    gaSessionId: string;
  };
  payload: Record<string, unknown>;
}

interface SendDataParams {
  eventData: {
    eventName: DataSchema['eventName'];
    schemaVersion: string;
    payload: DataSchema['payload'];
  };
  partitionKey: string;
}

/**
 * Sends the provided data to the Kinesis stream.
 */
export const sendData = async ({ eventData, partitionKey }: SendDataParams): Promise<void> => {
  const cookies = cookie.parse(document.cookie);
  const { commitHash } = config;

  const data: DataSchema = {
    eventName: eventData.eventName,
    schemaVersion: eventData.schemaVersion,
    commitHash: commitHash,
    releaseVersion: cookies.pd_rv,
    timestamp: new Date().toISOString(),
    payload: { ...eventData.payload },
    metadata: {
      referer: document.referrer,
      sessionId: cookies._ga,
      userAgent: navigator.userAgent,
      url: window.location.href,
      customerId: cookies.customerId,
      ninetailedAudiences: cookies.pd_audiences,
      ninetailedExperiences: cookies.pd_ninetailed,
      gaSessionId: cookies._ga || '',
    },
  };

  try {
    const response = await axios.post(KINESIS_ENDPOINT, {
      data: JSON.stringify(data),
      partitionKey,
      streamArn: STREAM_ARN,
    });
    if (response.status !== 200) {
      throw new Error(response.data.error || 'Failed to send data to Kinesis');
    }
  } catch (error) {
    if (axios.isAxiosError(error)) {
      console.error('Error sending data:', error.response?.data || error.message);
    } else {
      console.error('Error sending data:', error);
    }
    throw error;
  }
};
